@import '~style-sheet-helpers/core.less';
@import '../../../../../../../constants/spacing.module.less';

.action-type-selector {
  display: flex;
  flex-direction: column;
}

.action-type-dropdown-wrapper {
  width: 100%;
}

.action-selector {
  display: flex;
  flex-direction: column;
  > div {
    width: 100%;
    &:first-of-type {
      font-size: 14px;
      line-height: 24px;
      font-weight: 500;
    }
    &:last-of-type {
      padding: @space-4 0;
    }
  }
}
